var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9231 9.64648H10.4923",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20773 1.26954C8.4097 1.06757 8.68363 0.954102 8.96927 0.954102C9.1107 0.954102 9.25074 0.981958 9.38141 1.03608C9.51207 1.0902 9.6308 1.16953 9.7308 1.26954C9.83081 1.36955 9.91014 1.48827 9.96426 1.61894C10.0184 1.7496 10.0462 1.88965 10.0462 2.03108C10.0462 2.17251 10.0184 2.31256 9.96426 2.44322C9.91014 2.57389 9.83081 2.69261 9.7308 2.79262L3.38465 9.13877L1.35388 9.64646L1.86157 7.61569L8.20773 1.26954Z",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ea73ef2c.svg";
export { ForwardRef as ReactComponent };